import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Field, Form, Formik } from "formik";
import LoadingButton from "app/main/shared-components/loading-button/LoadingButton";
import { TextField } from "@material-ui/core";
import { increasePriceStyle } from "./Increase-price.style";
import ConfigurationServices from "../../../services/configuration.services";
import { useDispatch } from "react-redux";
import {errorMsg, successMsg} from "../../../utils/MessageUtils";
import * as yup from "yup";

const validationSchema = yup.object({
  price: yup
    .number()
    .required('Price is required')
    .min(0, 'Price must be greater than or equal to 0')
});

const IncreasePrice = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const classes = increasePriceStyle();
  const configurationService = ConfigurationServices;

  const [currentPrice, setCurrentPrice] = useState<number>(0);
  const [isLoading, setIsLoading] = useState(false);

  const fetchCurrentPrice = () => {
    configurationService.getIncreasePriceOnlineBooking().then((res) => {
      setCurrentPrice(res.increasePriceForThirdParty);
    }, (error: any) => {
      dispatch(errorMsg(error?.data?.message || 'Failed to fetch current price'));
    });
  }

  useEffect(() => {
    fetchCurrentPrice();
  }, []);

  const onSubmitHandler = (data: any) => {
    setIsLoading(true);
    configurationService.updateIncreasePriceOnlineBooking(data.price).then(() => {
      dispatch(successMsg(localStorage.getItem('i18nextLng') === 'en'
        ? 'Price updated successfully!'
        : 'Çmimi u përditësua me sukses!'));
      fetchCurrentPrice();
      setIsLoading(false);
    }, (error: any) => {
      dispatch(errorMsg(error?.data?.message || 'Failed to update price'));
      setIsLoading(false);
    })
  }

  return (
    <div className={classes.formWrapper}>
      <div>
        <h1 className={classes.colorBlue}>
          {t("app.configuration.increasePrice", "Increase Price for Online Booking")}:
        </h1>
        <p className={classes.currentPrice}>
          {t("app.configuration.currentPrice", "Current Price")}: {currentPrice}
        </p>
      </div>
      <Formik
        initialValues={{
          price: currentPrice
        }}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          onSubmitHandler(values);
        }}>
        {({ errors, touched, handleChange, values }) => (
          <Form>
            <Field
              className={classes.width100}
              onChange={handleChange}
              variant='outlined'
              name='price'
              value={values.price}
              label={t("app.configuration.price", "Price")}
              error={Boolean(errors?.price && touched?.price)}
              helperText={touched?.price ? errors?.price : ""}
              size='small'
              as={TextField}
              type='number'
              required
            />
            <LoadingButton
              type="submit"
              btnTitle={t("app.main.flights.flightList.editPage.saveChanges", "Save Changes")}
              isLoading={isLoading}
            />
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default IncreasePrice;
